type ToastID = string;

const TTL = 5 * 60 * 1000;
const shownToasts = new Map<ToastID, number>();

export function isToastSeen(id: ToastID): boolean {
  cleanupOldToasts();
  return shownToasts.has(id);
}

export function markToastAsSeen(id: ToastID): void {
  cleanupOldToasts();
  shownToasts.set(id, Date.now());
}

function cleanupOldToasts() {
  const now = Date.now();
  for (const [id, timestamp] of shownToasts.entries()) {
    if (now - timestamp > TTL) {
      shownToasts.delete(id);
    }
  }
}
